import styled from 'styled-components'

import { BREAKPOINT } from 'styles/breakpoints'

const IMAGE_BREAKPOINT = 375

export const StyledElementWithImage = styled.div<{
  backgroundUrl: string
}>`
  width: 100%;
  max-height: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  min-height: 280px;

  background: url(${({ backgroundUrl }) => backgroundUrl}) center / contain;
  background-repeat: no-repeat;

  @media screen and (min-width: ${IMAGE_BREAKPOINT}px) {
    background: url(${({ backgroundUrl }) => backgroundUrl}) center / cover;
  }

  @media screen and (min-width: ${BREAKPOINT.LG}px) {
    min-height: 400px;
  }

  @media screen and (min-width: ${BREAKPOINT.XL}px) {
    width: 528px;
  }

  @media screen and (min-width: ${BREAKPOINT.XXL}px) {
    width: 100%;
  }
`
